import { ModalDescription } from '@src/common/components/modal/ModalDescription';
import type { Timestamp } from '@src/common/time/Timestamp';
import { useTranslation } from 'react-i18next';

type Props = {
  orderDisplayId: string;
  clientName: string;
  createdAt: Timestamp;
};

export const ModalOrderDescription = (props: Props) => {
  const { t } = useTranslation();

  return (
    <ModalDescription
      labelsToValue={[
        {
          label: t('client'),
          value: props.clientName,
        },
        {
          label: t('orderSummary.orderNumber'),
          value: props.orderDisplayId,
        },
        {
          label: t('orderSummary.createdOn'),
          value: props.createdAt.formatDate(),
        },
      ]}
    />
  );
};
